// extracted by mini-css-extract-plugin
export var category = "_jb-9";
export var categoryHeader = "_jb-e";
export var container = "_jb-0";
export var group = "_jb-a";
export var groupItems = "_jb-f";
export var groupSeparator = "_jb-j";
export var loading = "_jb-1";
export var noResults = "_jb-3";
export var placeholder = "_jb-2";
export var resultContent = "_jb-5";
export var resultIcon = "_jb-c";
export var resultItem = "_jb-g";
export var resultMeta = "_jb-8";
export var resultSubtitle = "_jb-7";
export var resultSuffix = "_jb-i";
export var resultTitle = "_jb-6";
export var resultsList = "_jb-4";
export var searchGroup = "_jb-d";
export var selected = "_jb-h";
export var subgroup = "_jb-b";